export default {
  OK: "ok",
  ERROR: "error",
  ALARM: "alarm"
};
